import { useState, useEffect } from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { authLogout } from "../../server";
import { logoutUser } from "../../store/authSlice";
import { wsDisconnect } from "store/websocketSlice";
import { baseOrigin, baseOrigin2 } from "config";
const NETWORK_LINES = [
  {
    name: 'line1',
    route: "Line1",
    url: baseOrigin,
  },
  {
    name: "line2",
    route: "Line2",
    url: baseOrigin2,
  },
];

const PersonalHeader = () => {
  const { t, i18n } = useTranslation("admin");
  const dispatch = useDispatch();
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const [showLangMenu, setShowLangMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [networkMenuOpen, setNetworkMenuOpen] = useState(false);

  /* 退出登录 */
  const handleLogout = async () => {
    try {
      await authLogout();
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("artworkNid");
      dispatch(logoutUser());
      dispatch(wsDisconnect());
      window.location.href = "/login";
    }
  };

  /* 切换线路 */
  const switchNetwork = (line) => {
    const network = {
      route: line.route,
      url: line.url,
      name: line.name,
      success: true,
      time: 0,
    };
    sessionStorage.setItem(
      "network",
      JSON.stringify(network)
    );
    // 刷新页面让所有请求立即生效
    window.location.reload();
  };

  const currentNetwork =
    JSON.parse(sessionStorage.getItem("network")) || {};

  /* 切换语言 */
  const changeLanguage = (lng) => {

    i18n.changeLanguage(lng);

    setShowLangMenu(false);
  };

  const currentLanguageTitle =
    i18n.language === "en"
      ? "Language"
      : "语言";

  return (
    <Navbar
      expand="lg"
      className="px-md-4 shadow-sm"
    >

      {/* LOGO / 标题 */}
      <Navbar.Brand>
        {/* {t("appTitle")} */}
        BioVis Platform
      </Navbar.Brand>

      <Navbar.Collapse
        id="basic-navbar-nav"
        className="justify-content-end"
      >
        <Nav className="align-items-center gap-2">
          {/* 首页按钮 */}
          <Button
            variant="primary"
            className="d-flex align-items-center gap-2 sanger-top-btn"
            onClick={() => {
              window.open("/home", "_blank");
            }}
          >
            <i className="bi bi-house-door" />
            {t("home")}
          </Button>
          {/* 线路切换 */}
          <div className="position-relative">
            {/* 按钮 */}
            <Button
              variant="primary"
              className="d-flex align-items-center gap-2 sanger-top-btn"
              onClick={() => {
                setNetworkMenuOpen(!networkMenuOpen);
              }}
            >
              <i className="bi bi-hdd-network" />
              {t(currentNetwork?.name || 'switchLine')}
            </Button>

            {/* 菜单 */}
            {networkMenuOpen && (
              <>
                {/* 遮罩 */}
                <div
                  className="sanger-fixed"
                  onClick={() => setNetworkMenuOpen(false)}
                />

                <div className="sanger-menu">
                  {NETWORK_LINES.map((line) => (
                    <div
                      className="sanger-menu-item"
                      key={line.route}
                      onClick={() => {
                        switchNetwork(line);
                        setNetworkMenuOpen(false);
                      }}
                    >
                      <i
                        className="bi bi-check2"
                        style={{
                          visibility:
                            currentNetwork.url === line.url
                              ? "visible"
                              : "hidden",
                        }}
                      />
                      <span>
                        {t(line.name)}
                      </span>
                    </div>
                  ))}

                </div>
              </>
            )}

          </div>

          {/* 多语言切换 */}
          <div className="position-relative">

            <Button
              variant="primary"
              className="d-flex align-items-center gap-2 sanger-top-btn"
              onClick={() => {
                setShowLangMenu(!showLangMenu);
              }}
            >
              <i className="bi bi-translate" />

              {currentLanguageTitle}
            </Button>

            {showLangMenu && (
              <>
                <div
                  className="sanger-fixed"
                  onClick={() => setShowLangMenu(false)}
                />
                <div className="sanger-menu">
                  {[
                    {
                      key: "en",
                      label: "English",
                    },
                    {
                      key: "zh",
                      label: "简体中文",
                    },
                  ].map((lang) => {

                    const active =
                      i18n.language === lang.key ||
                      (
                        lang.key === "zh" &&
                        i18n.language.startsWith("zh")
                      );

                    return (
                      <div
                        className="sanger-menu-item"
                        key={lang.key}
                        onClick={() => {
                          changeLanguage(lang.key);
                        }}
                      >
                        <i
                          className="bi bi-check2"
                          style={{
                            visibility: active
                              ? "visible"
                              : "hidden",

                            fontSize: 16,
                          }}
                        />
                        <span>
                          {lang.label}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

          </div>

          {/* 用户菜单 */}
          <div className="position-relative">

            <Button
              variant="primary"
              className="d-flex align-items-center gap-2 sanger-top-btn"
              onClick={() => {
                setShowUserMenu(!showUserMenu);
              }}
            >
              <i className="bi bi-person-circle" />
              {t('user')}
            </Button>
            {showUserMenu && (
              <>
              <div 
                className="sanger-fixed"
                onClick={() => setShowUserMenu(false)}
              />
              <div className="sanger-menu">
                {/* 个人中心 */}
                <div
                  className="sanger-menu-item"
                  onClick={() => {
                    window.location.href =
                      "/personal/center";
                  }}
                >
                  <i className="bi bi-person" />
                  <span>
                    {t("personalCenter")}
                  </span>
                </div>
                {/* 退出登录 */}
                <div
                  className="sanger-menu-item"
                  style={{color:'var(--sanger-red-color)'}}
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right" />
                  <span>
                    {t("logout")}
                  </span>
                </div>
              </div>
              </>
            )}
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default PersonalHeader;